<template>
	<div class="artwork-filter">
		<select class="category-navigation-list" v-model="selectedCategory" @change="onChange">
			<option value="">
				All Categories
			</option>
			<option v-for="category in categories" :key="category.term_id" :value="category.slug">
				{{ category.name }}
			</option>
		</select>
	</div>
</template>

<script>
export default {
	emits: ['change'],

	data() {
		return {
			isLoading: false,
			isError: false,

			selectedCategory: '',

			categories: [
				// sample format
				// {
				// 	term_id: 22,
				// 	name: "Emerging Artist",
				// 	slug: "emerging-artist",
				// 	term_group: 0,
				// 	term_taxonomy_id: 22,
				// 	taxonomy: "artwork_category",
				// 	description: "",
				// 	parent: 0,
				// 	count: 2,
				// 	filter: "raw"
				// }
			]
		}
	},

	mounted() {
		this.getCategories();
	},

	methods: {
		getCategories() {
			this.isLoading = true;

			this.$store.dispatch('getCategories')
				.then((response) => {
					this.categories = this.$store.getters.getCategories;
				})
				.catch(error => {
					console.error('getCategories', error);
					this.isError = true;
				})
				.finally(() => {
					this.isLoading = false;
				})
		},

		onChange(event) {
			event.stopImmediatePropagation();
			this.$emit('change', this.selectedCategory);
		}
	}
}

</script>